import PropTypes from "prop-types";
import { useCallback, useState } from "react";
import MediaCarouselItem from "app/pages/Merchandising/Media/MediaCarouselItem";
import { RESOLUTION } from "app/constants";
import { resolutionPropType } from "app/utils/propTypes";
import "./MediaCarousel.scss";
import BackgroundProgressiveImg from "app/pages/.shared/BackgroundProgressiveImg";
import Swiper from "react-id-swiper";
import get from "lodash/get";
import IconNext from "app/pages/.shared/static/icons/IconNext";
import IconPrevious from "app/pages/.shared/static/icons/IconPrevious";
import { sendTagOnMediaClickDesktop } from "app/utils/analytics";

const IMG_SIZES_SMALL = {
	small: { width: 500 },
	medium: { width: 500 },
};

const CLOUDINARY_OPTIONS = ["c_fill", "g_center"];

const MAX_SLIDES_BEFORE_DISABLE_CAROUSSEL = 3;

const MediaCarousel = ({
	mediaList = [],
	onCarouselMediaClick = () => {},
	onMediaClick = () => {},
	resolution,
}) => {
	const [activeArticleTitle, setActiveArticleTitle] = useState(
		mediaList.length > 0 ? mediaList[0].title : undefined
	);

	const handleCarouselMediaItemClick = useCallback(articleTitle => {
		onCarouselMediaClick(articleTitle);
		sendTagOnMediaClickDesktop(articleTitle);
		setActiveArticleTitle(articleTitle);
	}, []);

	const handleMediaItemClick = useCallback(articleTitle => {
		onMediaClick(articleTitle);
		setActiveArticleTitle(articleTitle);
	}, []);

	const swiper_params = {
		spaceBetween: 20,
		slidesPerView: MAX_SLIDES_BEFORE_DISABLE_CAROUSSEL,
		navigation: {
			nextEl: ".media-carousel__button--next",
			prevEl: ".media-carousel__button--previous",
		},
		containerClass: "swiper-container media-carousel",

		// eslint-disable-next-line react/no-multi-comp
		renderPrevButton: () =>
			mediaList.length > MAX_SLIDES_BEFORE_DISABLE_CAROUSSEL && (
				<IconPrevious
					className="media-carousel__button media-carousel__button--previous"
					data-testid="carousel-previous-button"
				/>
			),

		// eslint-disable-next-line react/no-multi-comp
		renderNextButton: () =>
			mediaList.length > MAX_SLIDES_BEFORE_DISABLE_CAROUSSEL && (
				<IconNext
					className="media-carousel__button media-carousel__button--next"
					data-testid="carousel-next-button"
				/>
			),
		allowSlidePrev: mediaList.length > MAX_SLIDES_BEFORE_DISABLE_CAROUSSEL,
		allowSlideNext: mediaList.length > MAX_SLIDES_BEFORE_DISABLE_CAROUSSEL,
	};

	return resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM ? (
		<div className="media-carousel__photos">
			{mediaList[1] && (
				<div className="media-carousel__photo" onClick={handleMediaItemClick}>
					<BackgroundProgressiveImg
						sizes={IMG_SIZES_SMALL}
						cloudinaryOptions={CLOUDINARY_OPTIONS}
						src={mediaList[1].image}
						thumbnail={mediaList[1].thumbnail}
						backgroundPosition="center"
					/>
				</div>
			)}
			{mediaList[2] && (
				<div className="media-carousel__photo" onClick={handleMediaItemClick}>
					<BackgroundProgressiveImg
						sizes={IMG_SIZES_SMALL}
						cloudinaryOptions={CLOUDINARY_OPTIONS}
						src={mediaList[2].image}
						thumbnail={mediaList[2].thumbnail}
						backgroundPosition="center"
					/>
				</div>
			)}
		</div>
	) : (
		<div className="media-carousel__caroussel">
			<Swiper {...swiper_params}>
				{mediaList.map(mediaItem => {
					return (
						<div key={mediaItem.title}>
							<MediaCarouselItem
								isActive={activeArticleTitle === mediaItem.title}
								videoPreviewUrl={get(mediaItem, "video.previewUrl")}
								photoUrl={mediaItem.image}
								photoThumbnail={mediaItem.thumbnail}
								title={mediaItem.title}
								resolution={resolution}
								onClick={handleCarouselMediaItemClick}
							/>
						</div>
					);
				})}
			</Swiper>
		</div>
	);
};

MediaCarousel.propTypes = {
	mediaList: PropTypes.arrayOf(PropTypes.object),
	resolution: resolutionPropType,
	onCarouselMediaClick: PropTypes.func,
	onMediaClick: PropTypes.func,
};

export default MediaCarousel;
